module.exports = __webpack_public_path__ + "static/media/acto_de_grado_1.0e391138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_1.jpg
// module id = 908
// module chunks = 0